import closeIcon from "include/images/dark-close-icon.svg";
import { Offcanvas } from "react-bootstrap";

const ViewAllDayProgressionFlyer = ({ showModal, toggleModal, dailyProgression }) => {
  return (
    <Offcanvas
      className={"offcanvas offcanvas-end custom-offcanvas-pannel custom-offcanvas-pannel2 "}
      show={showModal}
      onHide={toggleModal}
      id="rewardPannel"
      placement="right"
      name="rewardPannel"
      backdrop={true}
      backdropClassName={"modal-backdrop z-index-1000"}
    >
      <Offcanvas.Header>
        <div>
          <h5>Attempts</h5>
        </div>
        <div className="btn_close pointer" data-bs-dismiss="offcanvas" aria-label="Close" onClick={toggleModal}>
          <img src={closeIcon} alt="" />
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="fwc-body">
          <div className="table-responsive">
            <div className="table-responsive">
              <table className="table custom-table-striped">
                <thead>
                  <tr>
                    <th>Stage/Gear/Spin</th>
                    <th>D1</th>
                    <th>D2</th>
                    <th>D3</th>
                    <th>D4</th>
                    <th>D5</th>
                    <th>D6</th>
                    <th>D7</th>
                  </tr>
                </thead>
                <tbody className="text-capitalize">
                  {dailyProgression["D1"] &&
                    Object.keys(dailyProgression["D1"])?.length > 0 &&
                    Object.keys(dailyProgression["D1"])?.map((key, index) => (
                      <tr key={index}>
                        <td>{key}</td>
                        {Object.keys(dailyProgression)?.map((day) => (
                          <td>{dailyProgression[day][key]}</td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewAllDayProgressionFlyer;
